import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezone',
  standalone: false,
})
export class TimezonePipe implements PipeTransform {
  public transform(
    value: Date | undefined,
    language: string,
    format: 'short' | 'long' | 'shortOffset' | 'longOffset' | 'shortGeneric' | 'longGeneric' | undefined,
  ): string {
    if (value) {
      // date time format to english pattern
      const dtf1 = new Intl.DateTimeFormat(language, { timeZoneName: format });

      if (dtf1) {
        return dtf1.formatToParts(value).find((x) => x.type === 'timeZoneName')?.value ?? '';
      }
    }

    return '';
  }
}
